import React, { useState } from "react";
import { Card, Col, Form, Row, Button } from "react-bootstrap";
import { FiCopy, FiCheck } from "react-icons/fi";
import { FaRegEdit } from "react-icons/fa";
import { userServices } from "../../APIServices/UserData/userServices";
import Swal from "sweetalert2";
import UseToggle from "../../Hooks/UseToggle";
import ChangeEmail from "./ChangeEmail";

const ManageProfile = ({ currentUserData, getCurrectLoginUser }) => {
  const toggles = UseToggle();
  const [loader, setLoader] = useState(false);
  const [edit, setEdit] = useState({
    orgName: false,
    email: false,
  });

  const [copied, setCopied] = useState({
    orgName: false,
    email: false,
  });

  const [formData, setFormData] = useState({
    orgName: currentUserData?.name,
    email: currentUserData?.email,
  });

  const [backupData, setBackupData] = useState({ ...formData });

  const copyToClipboard = (field, value) => {
    navigator.clipboard.writeText(value);
    setCopied((prev) => ({ ...prev, [field]: true }));

    setTimeout(() => {
      setCopied((prev) => ({ ...prev, [field]: false }));
    }, 2000);
  };

  const startEdit = (field) => {
    setBackupData(formData);
    setEdit((prev) => ({ ...prev, [field]: true }));
  };

  const saveEdit = (field) => {
    setEdit((prev) => ({ ...prev, [field]: false }));
  };

  const cancelEdit = (field) => {
    setFormData(backupData);
    setEdit((prev) => ({ ...prev, [field]: false }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const updateProfile = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Profile Name?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.fullName = formData?.orgName;
        let data = await userServices.updateProfile(userData);
        if (data?.statusCode === 200) {
          getCurrectLoginUser()
          saveEdit("orgName")
          const existingList =
            JSON.parse(localStorage.getItem("accountList")) || [];
          let fianlList = existingList.map(user =>
            user.email === currentUserData?.email
              ? { ...user, name: formData?.orgName }
              : user
          );
          localStorage.setItem("accountList", JSON.stringify(fianlList));
        }
        setLoader(false);
      }
    });
  };

  const renderIcons = (field, value) => (
    <div className="d-flex gap-2 align-items-center">
      {copied[field] ? (
        <FiCheck className="text-success" />
      ) : (
        <FiCopy
          className="cursor-pointer text-muted"
          onClick={() => copyToClipboard(field, value)}
        />
      )}

      <FaRegEdit
        className="text-muted cursor-pointer"
        onClick={() =>
          field === "orgName"
            ? startEdit(field)
            : toggles.setToggle()
        }
      />
    </div>
  );

  return (
    <div className="h-100 d-flex flex-column">
      <div className="bg-white border-bottom px-4 py-3">
        <h6 className="fw-semibold m-0">Manage Your Account</h6>
      </div>

      <div className="flex-grow-1 overflow-auto p-4">
        <Row className="g-4 justify-content-center">
          <Col xxl={4} lg={6} md={8}>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <Form.Group>
                  <div className="hstack justify-content-between">
                    <Form.Label>Organization Name</Form.Label>
                    {!edit.orgName && renderIcons("orgName", formData.orgName)}
                  </div>

                  {!edit.orgName ? (
                    <Form.Text>{formData.orgName}</Form.Text>
                  ) : (
                    <>
                      <Form.Control
                        name="orgName"
                        value={formData.orgName}
                        onChange={handleChange}
                        autoFocus
                      />
                      <div className="mt-2 d-flex gap-2">
                        <Button
                          size="sm"
                          onClick={updateProfile}
                          disabled={loader || !formData?.orgName}
                        >
                          Save
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onMouseDown={() => cancelEdit("orgName")}
                        >
                          Cancel
                        </Button>
                      </div>
                    </>
                  )}
                </Form.Group>
              </Card.Body>
            </Card>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <Form.Group>
                  <div className="hstack justify-content-between">
                    <Form.Label>Email Address</Form.Label>
                    {renderIcons("email", formData.email)}
                  </div>
                  <Form.Text>{formData.email}</Form.Text>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      <ChangeEmail
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Change Email"
        currentEmail={currentUserData?.email}
        getCurrectLoginUser={getCurrectLoginUser}
      />
    </div>
  );
};

export default ManageProfile;
